import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'

export class CollectionGrid extends React.PureComponent<CollectionGrid.Props, CollectionGrid.State> {
  public static sectionId = 'collectionGrid';
  private slider: any

  constructor(props) {
    super(props)
    this.slider = React.createRef()
  }

  public next = () => {
    this.slider.current.slickNext()
  }

  public previous = () => {
    this.slider.current.slickPrev()
  }
  public render(): JSX.Element {
    const { section } = this.props
    const { settings, blocks } = section
    const imageQuantity = section?.blocks.length ? section?.blocks.length : 1

    // Allow full width is used to remove overall parent container width constraints to allow articles to have full width images 
    let allow_full_width_images = this.props.data?.article?.settings?.allow_full_width_images
    const classes = imageQuantity === 1 ? 'w-full' : 'w-full md:w-1/2 px-1-6 md:px-0'
 
    const sliderSettings = {
      infinite: false,
      arrows: false,
      swipeToSlide: true,
      slidesToScroll: 1,
      slidesToShow: 4,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            swipeToSlide: true,
            arrows: false,
          }
        }
      ]
    }

    return (
      <section className={`dynamic-collection-grid mb-4-8 text-left w-full ${allow_full_width_images ? 'max-w-7xl mx-auto' : ''} pt-2 `}>
        {settings?.carouselToggle === true && blocks.length > 4 ? 
          <div className={'px-1-6 xl:px-0 flex justify-center md:justify-end mb-2 hidden md:flex mx-3'}>
            <Snippets.CustomCarouselArrows prev={this.previous} next={this.next} />
          </div> : null
        }
        <div className={`w-full ${settings?.carouselToggle === true ? 'md:w-full md:mx-3' : 'md:w-5/6 mx-auto' } ${blocks.length == 4 ? 'pr-0 md:pr-3' : '' } `}>          
          {settings?.carouselToggle === true ? 
            <Snippets.Slider refs={this.slider} settings={{ ...sliderSettings }} className={'cart-slider relative'}>
              {blocks?.map((block, i) => (
                <Snippets.ImageGridItem block={block} carouselToggle={settings?.carouselToggle} classes={''} key={i} />
              ))}         
            </Snippets.Slider>               
            :  (
              <div className={'w-full md:w-4/5 px-1-6 md:px-0-4 mx-auto flex flex-wrap'}> 
                {blocks?.map((block, i) => (
                  <Snippets.ImageGridItem block={block} carouselToggle={settings?.carouselToggle} classes={classes} key={i} />
                ))}        
              </div> 
            )}
        </div>
        {settings?.carouselToggle === true ?
          <div className={'mt-3-2 ml-1 md:hidden flex flex-row'}>
            <Snippets.CustomCarouselArrows prev={this.previous} next={this.next} />
          </div> : null
        }
      </section>
    )
  }
}

export namespace CollectionGrid {
  export interface Options extends ShopifyNext.Section {
    block_size: number;
  }
  export interface Props extends GlobalProps {
    section: CollectionGrid.Options;
  }
  export interface CollectionSettings {
    carouselToggle: boolean;
    src: string;
    linkurl: string;
    collectionTitle: string;
  }
  export interface State {}
}
